module.exports = __webpack_public_path__ + "img/绘画部.4a5ac0a1.jpg";